import React from "react"
import useFetch from "../../../../hooks/useFetch"
import { SelectInput, Spinner, Icon } from "asocomponents"
import ConceptoLiquidacionService from "../../../../../modules/ConceptoLiquidacion/application/ConceptoLiquidacionService"

function SelectConcepto({ onChange, width, valor }) {
  const conceptoLiquidacionService = new ConceptoLiquidacionService()
  const { isLoading, data, isFailed } = useFetch(
    conceptoLiquidacionService,
    "getConceptos"
  )

  if (isLoading) {
    return <Spinner color="red" size="10" />
  }

  if (isFailed) {
    return <Icon type="error" />
  }

  return (
    <div>
      <SelectInput options={data} placeholder="Seleccionar" todos={false} onChange={onChange} defaultValue={valor || "-2"} width={width} valueField="idConcepto"></SelectInput>
    </div>
  )
}

export default SelectConcepto